import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "src/app/shared/directives/user.service";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { AddTirageComponent } from "./add-tirage/add-tirage.component";
import { EditTirageComponent } from "./edit-tirage/edit-tirage.component";
import { RequestItem } from 'src/app/corporate/core/model/request-item';
import { CorporateTirage } from 'src/app/corporate/core/model/tirage/corporate-tirage';
import { RequestItemService } from 'src/app/corporate/core/service/request-item.service';
import { CorporateTirageService } from 'src/app/corporate/core/service/corporate-tirage.service';

@Component({
  selector: 'app-tirage-tab',
  templateUrl: './tirage-tab.component.html',
  styleUrls: ['./tirage-tab.component.scss'],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class TirageTabComponent implements OnInit {

  @Input() requestId: any;

  request: Request;
  items: RequestItem[];

  tirages: CorporateTirage[];
  tiragesArray: Array<CorporateTirage[]> = [];

  displayedFacilitesColumnsList: string[] = [
    "id",
    "produit.typeCredit.label",
    "produit.label",
    "montant",
    "echeance",
    "actions",
  ];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private userService: UserService,
    private _requestItemService: RequestItemService,
    private _requestService: RequestService,
    private _corporateTirageService: CorporateTirageService
  ) {}

  ngOnInit() {
    this.getRequestById(this.requestId);
    this.findAllFaciliteByRequestId(this.requestId);
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  findAllFaciliteByRequestId(requestId) {
    this._requestItemService.getListRequestItemByRequest(requestId).subscribe(
      (data) => {
        this.items = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  findAllTirageByFacilite(faciliteId) {
    this._corporateTirageService.findAllByFacilite(faciliteId).subscribe(
      (data) => {
        this.tirages = data;
        this.tiragesArray[faciliteId] = this.tirages;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  AddTirage(faciliteId) {
    const modalRef = this.modalService.open(AddTirageComponent, {
      centered: true,
    });
    modalRef.componentInstance.corporateFaciliteId = faciliteId;

    modalRef.result.then(
      (data) => {
        // on close
        this.findAllTirageByFacilite(faciliteId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  editTirage(faciliteId, corporateTirageId) {
    const modalRef = this.modalService.open(EditTirageComponent, {
      centered: true,
    });
    modalRef.componentInstance.corporateTirageId = corporateTirageId;

    modalRef.result.then(
      (data) => {
        // on close
        this.findAllTirageByFacilite(faciliteId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteTirage(faciliteId, corporateTirageId) {
    this._corporateTirageService
      .delete(corporateTirageId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.findAllTirageByFacilite(faciliteId);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  refreshTirage(faciliteId) {
    this.findAllTirageByFacilite(faciliteId);
  }

}
